module.exports = { raw: '8.12.3' };



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 9
// module chunks = 0 1